export default "__VITE_ASSET__C9H61jE0__"